(function() {
  function toggleCard(card, button) {
    var isClosed = card.classList.toggle('is-closed');
    button.textContent = isClosed ? 'Open' : 'Close';
    button.setAttribute('aria-expanded', String(!isClosed));
  }

  function toggleOfferItem(item, button) {
    var isOpen = item.classList.toggle('is-open');
    button.setAttribute('aria-expanded', String(isOpen));
  }

  function copyOfferCode(button) {
    var code = button.getAttribute('data-copy-offer-code');
    if (!code) return;
    navigator.clipboard.writeText(code).catch(function() {});
    button.textContent = 'Copied';
    setTimeout(function() {
      button.textContent = 'Copy Code';
    }, 1200);
  }

  function initOffersCard(card) {
    if (card.dataset.offersInit === 'true') return;
    card.dataset.offersInit = 'true';

    var cardToggleButton = card.querySelector('[data-offers-card-toggle]');
    if (cardToggleButton) {
      cardToggleButton.addEventListener('click', function() {
        toggleCard(card, cardToggleButton);
      });
    }

    card.addEventListener('click', function(event) {
      var offerToggleButton = event.target.closest('[data-offer-toggle]');
      if (offerToggleButton) {
        toggleOfferItem(offerToggleButton.closest('[data-offer-item]'), offerToggleButton);
        return;
      }

      var copyButton = event.target.closest('[data-copy-offer-code]');
      if (copyButton) {
        copyOfferCode(copyButton);
      }
    });
  }

  function initAllOffersCards(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-offers-card]').forEach(initOffersCard);
  }

  window.MiraviOffersCard = window.MiraviOffersCard || {};
  window.MiraviOffersCard.init = initAllOffersCards;

  document.addEventListener('DOMContentLoaded', function() {
    initAllOffersCards();
  });

  document.addEventListener('shopify:section:load', function(event) {
    initAllOffersCards(event.target);
  });
})();
